var React = require('react');

function HSearchInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-path"},React.createElement("path",{"id":"Clip_2","data-name":"Clip 2","d":"M0,0H28V28H0Z","fill":"none"}))),React.createElement("path",{"id":"Clip_2-2","data-name":"Clip 2","d":"M0,0H28V28H0Z","fill":"none","key":1}),React.createElement("g",{"id":"_013-search-2","data-name":"013-search","clipPath":"url(#clip-path)","key":2},React.createElement("path",{"id":"Fill_1","data-name":"Fill 1","d":"M27.417,28A.576.576,0,0,1,27,27.829l-8.519-8.519a11.142,11.142,0,1,1,.824-.825L27.829,27a.584.584,0,0,1,0,.824A.576.576,0,0,1,27.417,28ZM11.084,1.166A9.917,9.917,0,1,0,21,11.084,9.928,9.928,0,0,0,11.084,1.166Z","fill":"#fff"}))]);
}

HSearchInline.defaultProps = {"id":"_013-search","data-name":"013-search","width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = HSearchInline;

HSearchInline.default = HSearchInline;
